import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { PosDeviceContext } from '../context/PosDeviceContext';

export default function PosDeviceRoute({ children }) {
  const { user } = useContext(AuthContext);
  const { loading, enrolled, device } = useContext(PosDeviceContext);
  const isAdmin = user?.role === 'Admin';

  if (loading) {
    return <div className="loading" style={{ padding: 24, textAlign: 'center' }}>Checking POS terminal…</div>;
  }

  // Admins can open the live POS (store picker) without a terminal enrollment.
  // Cashiers / store staff still require an enrolled desktop.
  if (!enrolled && !isAdmin) {
    return (
      <div className="container" style={{ paddingTop: 32 }}>
        <div className="card">
          <h2>POS terminal not enrolled</h2>
          <p>
            POS is available only on a designated store desktop. Ask an administrator to generate a one-time
            enrollment link for this store.
          </p>
          <Link to="/" className="btn btn-secondary">Back to dashboard</Link>
        </div>
      </div>
    );
  }

  return React.cloneElement(children, { posDevice: enrolled ? device : null });
}
